<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="8"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <ellipse
      cx="10"
      cy="10"
      rx="3.5"
      ry="8"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M2.5 10H17.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M3.5 6H16.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M3.5 14H16.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
